/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  VStack,
  Image,
  ModalHeader,
  ModalCloseButton,
  HStack,
  Select,
  TextProps,
  Checkbox,
  Box,
  useToast,
} from '@chakra-ui/react';
import { useTheme } from '../../../contexts/ThemeProvider';
import { Text } from '../../../components/atoms/Text';
import React, { useEffect, useState } from 'react';
import { numberToBRL } from '../../../utils';
import { Button } from '../../../components/atoms/Button';

import { WaitingPayment } from './WaitingPayment';
import { HowToUse } from './HowToUse';
import { buyProduct } from '@/service/user/api';
import { APP_EVENTS, spawnAppEvent } from '@/service/utils';
import { cacheBust } from '@/utils/cacheBust';

export function Label(props: TextProps) {
  return <Text color="#000000" fontFamily={'Glory'} fontWeight={'400'} fontSize={14} {...props} />;
}

export function ProductModal({
  isOpen,
  onClose,
  discount,
  show_name,
  logo,
  rules,
}: {
  discount: any;
  show_name?: string;
  logo?: string;
  isOpen: boolean;
  onClose: () => void;
  rules: string;
}) {
  const { colors, logo: logoTheme, isApp } = useTheme();
  const [quantity, setQuantity] = React.useState(1);
  const [checked, setChecked] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [link, setLink] = React.useState();
  const [step, setStep] = React.useState(0);
  const [vindiId, setVindiId] = useState<string>();
  const toast = useToast();

  async function generatePaymentLinkAndRedirect() {
    try {
      setIsLoading(true);

      const response: any = await buyProduct(discount?.id, quantity);

      setVindiId(response.data.id);
      setLink(response.data.url);
      if (isApp) spawnAppEvent(APP_EVENTS.OPEN_LINK, response.data.url);
      else window.open(response.data.url, '_blank');

      setStep(2);
    } catch (error: any) {
      toast({
        title: error?.response?.data?.error || 'Erro ao gerar o link de pagamento.',
        status: 'error',
        duration: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (!isOpen) return;
  }, [isOpen]);

  return (
    <Modal
      onClose={() => {
        onClose();
        setStep(0);
        setChecked(false);
        setQuantity(1);
        setLink(undefined);
      }}
      isCentered
      id="virtual-card-modal"
      isOpen={isOpen}
    >
      <ModalOverlay />
      <ModalContent margin={'20px'} padding="15px 5px" borderRadius={'16px'}>
        <ModalHeader>{step === 0 ? 'Usar o desconto' : <Image src={logoTheme} height={35} />}</ModalHeader>
        <ModalCloseButton color={colors.primaryColor} />
        <ModalBody>
          {step === 0 && (
            <VStack align={'flex-start'} spacing={4}>
              <Label>Apresente o cartão virtual, gerado após a compra, ao estabelecimento conveniado.</Label>
              <Label>
                Valor Unitário: <b>{numberToBRL(Number(discount.buyPrice))}</b>
              </Label>
              <HStack>
                <Label>Quantidade:</Label>
                <Select
                  borderRadius={'20px'}
                  defaultValue={1}
                  size="sm"
                  fontSize={14}
                  onChange={(e) => setQuantity(Number(e.target.value))}
                >
                  {new Array(discount.monthly_max_usage_per_user || 4).fill(0).map((_, index) => (
                    <option key={index} value={index + 1}>
                      {index + 1} ({numberToBRL((index + 1) * discount.buyPrice)})
                    </option>
                  ))}
                </Select>
              </HStack>
              <Label>
                Valor Total: <b>{numberToBRL(Number(discount.buyPrice * quantity))}</b>
              </Label>
              <Button onClick={() => setStep(1)}>Comprar</Button>
            </VStack>
          )}
          {step === 1 && (
            <VStack align={'flex-start'} spacing={4}>
              <Box overflow={'auto'} maxHeight={'50vh'} width={'100%'}>
                <VStack align={'flex-start'}>
                  <Image margin={'auto'} height={100} src={cacheBust(logo)} />
                  <Label fontWeight="500" fontSize="18px">
                    Resumo do pedido
                  </Label>
                  <Label>
                    Empresa: <b>{show_name}</b>
                  </Label>
                  <Label>
                    Quantidade: <b>{quantity}</b>
                  </Label>
                  <Label>
                    Valor Total: <b>{numberToBRL(Number(discount.buyPrice * quantity))}</b>
                  </Label>
                </VStack>
                <VStack align={'flex-start'}>
                  <Label>
                    <b>Regulamento:</b>
                  </Label>
                  <Label dangerouslySetInnerHTML={{ __html: rules?.replaceAll('\n', '<br/>') }} />
                </VStack>
                <HowToUse name={show_name} />
              </Box>

              <Checkbox isChecked={checked} onChange={(e) => setChecked(e.target.checked)}>
                <b>Li o regulamento e estou de acordo.</b>
              </Checkbox>
              <HStack width={'100%'} spacing={2}>
                <Button
                  borderColor={'#242424'}
                  backgroundColor="white"
                  color={'#242424'}
                  width="30%"
                  variant="outline"
                  onClick={() => setStep(0)}
                >
                  Voltar
                </Button>
                <Button
                  onClick={generatePaymentLinkAndRedirect}
                  isLoading={isLoading}
                  width="70%"
                  isDisabled={!checked}
                >
                  Confirmar
                </Button>
              </HStack>
            </VStack>
          )}
          {step === 2 && vindiId && link && <WaitingPayment id={vindiId} link={link} onClose={onClose} />}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
